/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Lemon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Lemon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="M20.109 3.891c2.252 2.253.663 2.433 1.095 3.41 1.613 3.636.763 8.247-2.447 11.456-3.21 3.21-7.82 4.06-11.457 2.447-.976-.432-2.658-.345-3.409-1.095-.75-.751-.663-2.433-1.095-3.41-1.613-3.636-.763-8.247 2.447-11.456 3.21-3.21 7.82-4.06 11.457-2.447.976.432 1.156-1.157 3.409 1.095"
      />
      <path
        fill="#FFF3D2"
        fillRule="evenodd"
        d="M6.594 7.946a.956.956 0 0 1 0-1.352c1.159-1.158 2.675-1.907 4.16-2.278 1.476-.369 3.02-.39 4.251.02a.956.956 0 1 1-.604 1.813c-.796-.265-1.955-.286-3.183.021-1.217.304-2.404.907-3.272 1.776a.956.956 0 0 1-1.352 0"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const LemonIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'lemon-icon'}
      icon={Lemon}
      {...props}
      size={size}
    />
  );
};
